import loggingService from '../util/loggingService'

var serviceName = 'siteTypetService'
var path = '/Lookup/SiteType/'
var isDebug = false

function listLookup (http) {
    loggingService.log(isDebug, serviceName, 'List')

    return http.get(path + 'List')
}

export default {
    listLookup: listLookup
}



// WEBPACK FOOTER //
// ./src/services/lookup/siteTypeService.js